/**
 * TikTok for Business manage-screen copy. Spread into enIntegrations so
 * that file stays under the 500-line ceiling.
 */
export const enTikTokAds = {
  'tiktokAdsSettings.title': 'TikTok for Business',
  'tiktokAdsSettings.subtitle':
    'Connect your TikTok Marketing API app and see the advertiser accounts you already have access to',
  'tiktokAdsSettings.accountsTitle': 'Advertiser accounts',
  'tiktokAdsSettings.accountsEmpty':
    'No advertiser accounts were returned for this login. Confirm the TikTok user can access a Business Center advertiser, then Connect again.',
  'tiktokAdsSettings.accountLine': '{name} ({id})',
  'tiktokAdsSettings.connect': 'Connect TikTok for Business',
} as const;
